
/* App. Setting */
import { InjectionToken } from '@angular/core';

export let APP_CONFIG = new InjectionToken('app.config');

export interface IAppConfig {
    recaptcha: { siteKey: string };
    // id Catalogo Pasaporte
    pasaporteid : string;
    dniid : string;
    // Llaves de seguridad
    clientid: string;
    clientsecret: string;
    privateKeyEncript: string;
}
export const AppConfig: IAppConfig = {
    recaptcha: { siteKey: '6LfMVtwsAAAAAM1R3pztkaxj-rlS_j95R5B0dQ3h' },  // clave  6Lf4RdwsAAAAAFhoOCVq9w4J1Ziky96DOEaDq-Xy (Usa esta clave de sitio web en el código HTML que tu sitio web sirve a los visitantes.)
    pasaporteid : '60ddcb763cb65f332fa75b00',
    dniid : '6272eb83577d4b3218ec6ba6', // esta variable se setea cuando se registra el usuario 
    clientid: 'JUhQX1tgQ3UGKfbEdfkfDLIZ8',
    clientsecret: 'dlMzRhZTE0LmpwZyIsInBlcmZpbCI6I',
    privateKeyEncript: 'aVtRVLDRF5XwuAbM7pzggJ6uxWomOb8UTI91YGQH09IvvdSPGqx5QuP7pGt5',
};
